<template>
    <div class="choix-site-satisfaction">
        <SelectSite
            :is-multi-site="isMultiSite"
            :selected-sites="sites"
            :selectedSite="site"
            :sites-disabled="false"
            :societe-id="getSocieteId"
            :title="''"
            class="select-site-container"
            @add="addSite"
            @addAll="addAllSite"
            @pick="pick"
            @filter-change="pick(undefined)"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import SelectSite from '@/modules/SiteList/components/SelectSite.vue';
import { Site } from '@/models/Site';
import { store } from '@/plugins/store';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';

export default defineComponent({
    name: 'ChoixSiteSatisfaction',
    components: { SelectSite },
    props: {
        selectedSite: { type: Object as PropType<Site | undefined>, required: true },
        selectedSites: { type: Array as PropType<Site[]>, required: true },
        isMultiSite: { type: Boolean as PropType<boolean>, required: true },
    },
    computed: {
        getSocieteId(): number {
            return this.$store.getters['satisfactionState/getSocieteIdSelectionnee'];
        },
    },
    data(): { isAllSites: boolean; site: Site | undefined; sites: Site[] } {
        return {
            isAllSites: false,
            site: this.selectedSites.length === 1 ? this.selectedSites[0] : undefined,
            sites: this.selectedSites,
        };
    },
    mounted() {
        store.commit(`siteList/${SITE_LIST.RESET_FILTER}`);
    },
    methods: {
        validerSite() {
            if (this.isMultiSite) {
                this.$emit('valider', this.sites);
            } else {
                let site: Site | undefined;
                if (this.isAllSites) {
                    site = undefined;
                } else {
                    site = this.site;
                }
                this.$emit('valider', site);
            }
        },
        pick(site: Site) {
            if (site) {
                this.site = site;
                this.$emit('valider', site);
            }
        },
        addSite(sites: Site[]) {
            if (sites) {
                this.sites = sites;
                this.$emit('valider', sites);
            }
        },
        addAllSite(sites: Site[]) {
            this.sites = [...sites];
            // On informe le parent immédiatement
            this.$emit('valider', this.sites);
        },
        toogleAllSite(isAllSites: boolean) {
            this.isAllSites = isAllSites;
            this.sites = [];
            this.site = undefined;
        },
    },
});
</script>

<style scoped>
:deep(.card-content-container) {
    overflow: hidden;
}
.choix-site-satisfaction {
    padding: 0 8px 0 0;
}

.button-modal-container {
    text-align: right;
    padding-top: 8px;
}

.button-confirm {
    width: 100px;
    height: 40px;
    background-color: #424b54;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.button-confirm:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.select-site-container {
    background-color: var(--white);
    max-height: calc(100vh - 310px);
    padding: 0;
}

@media (max-height: 675px) {
    :deep(.card-content-container) {
        max-height: 65vh;
        padding: 0;
    }
    .select-site-container {
        height: 40vh;
    }
    :deep(.select-all-container) {
        display: flex;
        align-items: center;
        margin-top: -4%;
    }
}

@media (min-height: 676px) and (max-height: 775px) {
    :deep(.card-content-container) {
        padding: 0;
    }
    .select-site-container {
        height: 53vh;
    }
    :deep(.select-all-container) {
        display: flex;
        align-items: center;
        margin-top: -4%;
    }
    :deep(.search-bar) {
        margin: 8px 0 8px 0;
    }
}

@media (min-height: 776px) {
    .select-site-container {
        height: 64vh;
    }
    :deep(.select-all-container) {
        display: flex;
        align-items: center;
        margin-top: -2.5%;
    }
    :deep(.search-bar) {
        margin: 8px 0 0 0;
    }
}

/* R�gles suppl�mentaires */
:deep(.margin--10px) {
    margin-top: -10px;
}
:deep(.recherche-container) {
    display: flex;
}

:deep(.first-container) {
    width: 50%;
}
:deep(.search-bar) {
    width: 100%;
    margin-top: 0;
}
:deep(.title) {
    width: 50%;
}
</style>
